import apiClient from 'apiClient';
import axios, { AxiosPromise } from 'axios';
import { CaseStatus } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import { isCorrectResponse } from 'utils/api/error/ResponseError';
import { ExperianCheckError, ExperianAPIError } from '../credit/errors';
import isExperianError from '../credit/errors/isExperianError';

type SwitchStatusResponse = AxiosPromise<ChangeCaseStatusResponse>;

export type ActionsDone = 'HARD_FOOTPRINT';

interface ChangeCaseStatusResponse {
  actionsDone?: ActionsDone[];
}

const switchStatus = (endpoint: string) => (status: CaseStatus): SwitchStatusResponse => {
  return apiClient
    .post<ChangeCaseStatusResponse>(`${endpoint}/switch-status`, {
      status,
    })
    .catch((err: unknown) => {
      if (axios.isAxiosError(err) && isCorrectResponse<ExperianAPIError>(err.response) && isExperianError(err)) {
        throw new ExperianCheckError(err.response.data.error);
      }

      return Promise.reject(err);
    });
};

export default switchStatus;
